import { gunterzBold } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { Group, Loader, Modal, Text } from '@mantine/core';
import type { BuyCryptoModalProps } from './BuyCryptoModal';
import classes from './DepositBuyCrypto.module.css';
export const ProcessingModal: React.FC<BuyCryptoModalProps> = ({
  stack
}) => {
  const {
    i18n
  } = useLingui();
  return <Modal.Root {...stack.register('processing')} centered classNames={classes}>
      <Modal.Overlay />
      <Modal.Content w={426} h={230}>
        <Modal.Body h="100%">
          <Group gap={4} align="center" justify="center" h="100%">
            <Text fz="lg" c="var(--text-white)" className={gunterzBold.className}>
              {i18n._('Processing')}
            </Text>
            <Loader color="var(--text-white)" size="md" type="dots" />
          </Group>
        </Modal.Body>
      </Modal.Content>
    </Modal.Root>;
};